export default {
  pageTitle: 'Интеграции',
  pageSubtitle:
    'Подключите Laplace к инструментам, которые уже использует ваша команда, и получайте ответы на основе всего рабочего стека.',
  searchPlaceholder: 'Поиск интеграций...',

  categoryAll: 'Все',
  categoryTasks: 'Задачи и проекты',
  categoryDocs: 'Документы',
  categoryDev: 'Разработка',
  categoryMail: 'Почта',
  categoryCalendar: 'Календари',
  categoryOther: 'Другое',

  integrationsCount_one: '{{count}} интеграция доступна',
  integrationsCount_few: '{{count}} интеграции доступны',
  integrationsCount_many: '{{count}} интеграций доступно',

  noResultsTitle: 'Ничего не найдено',
  noResultsBody: 'Попробуйте другой запрос или выберите другую категорию.',

  connectedTitle: 'Подключено',
  connectedBadge: 'Доступно сейчас',
  connectedItemBadge: 'Подключено',
  jiraName: 'Jira',
  jiraDesc: 'Задачи, статусы и история решений по тикетам.',
  confluenceName: 'Confluence',
  confluenceDesc: 'Документация, спецификации и вики команды.',
  githubName: 'GitHub',
  githubDesc: 'Код, pull-request’ы и обсуждения изменений.',
  gmailName: 'Gmail',
  gmailDesc: 'Рабочая переписка и договорённости в почте.',
  yandexMailName: 'Yandex Mail',
  yandexMailDesc: 'Почта Яндекс 360 с хранением данных в РФ.',
  googleCalendarName: 'Google Calendar',
  googleCalendarDesc: 'Встречи, дедлайны и расписание.',
  yandexCalendarName: 'Yandex Calendar',
  yandexCalendarDesc: 'Календарь Яндекс 360 для команд.',

  soonTitle: 'Скоро',
  soonBadge: 'В разработке',
  soonItemBadge: 'Скоро',
  kaitenName: 'Kaiten',
  kaitenDesc: 'Канбан-доски и рабочие процессы команд.',
  weeekName: 'Weeek',
  weeekDesc: 'Задачи, проекты и база знаний.',
  yonoteName: 'Yonote',
  yonoteDesc: 'База знаний, заметки и внутренние регламенты команды.',
  outlookCalendarName: 'Outlook Calendar',
  outlookCalendarDesc: 'Встречи и расписание из Microsoft Outlook.',
  konturName: 'Контур',
  konturDesc: 'Документооборот и ЭДО.',
  telegramName: 'Telegram',
  telegramDesc: 'Рабочие каналы, чаты и быстрые командные обсуждения.',
  otherName: 'И другие',
  otherDesc: 'Новые источники добавляются по запросу.',

  ctaTitle: 'Нужна интеграция, которой нет в списке?',
  ctaBody:
    'Расскажите, с какими сервисами работает ваша команда — приоритизируем в дорожной карте.',
  ctaButton: 'Запросить интеграцию',
}
